import React from "react";
import Background from "../assets/images/accor-plus-logo.png";

const Logo = () => {
  let isProd = window.location.href.indexOf("accorplus") != -1;
  return (
    <div className="header-holder-logo pb-1 xs:p-2">
      <a href={isProd ? "https://www.accorplus.com" : "#"}>
        <img
          src={Background}
          className="header-logo"
          alt="Accorplus Logo"
          width="150px"
        />
      </a>
    </div>
  );
};

export default Logo;
